function PlayLandingPageIcon() {
  return (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_360_16558)">
        <circle cx="42.5" cy="38.5" r="35.5" fill="#00AAB0" />
      </g>
      <path
        d="M57.1787 34.5571C59.797 36.1056 59.797 39.8944 57.1787 41.4429L38.2863 52.6165C35.6198 54.1935 32.25 52.2715 32.25 49.1736L32.25 26.8264C32.25 23.7285 35.6198 21.8065 38.2863 23.3835L57.1787 34.5571Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_360_16558"
          x="0.4"
          y="0.4"
          width="86.2"
          height="86.2"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_360_16558"
          />
          <feOffset dx="1" dy="5" />
          <feGaussianBlur stdDeviation="3.3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.126389 0 0 0 0 0.126389 0 0 0 0 0.126389 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_360_16558"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_360_16558"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export { PlayLandingPageIcon };
